import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");
        if (code) {
          const { error } = await supabase.auth.exchangeCodeForSession(code);
          if (error) throw error;
        }
        navigate("/", { replace: true });
      } catch (e) {
        setError(e.message || "Sign-in failed");
        setTimeout(() => navigate("/auth", { replace: true }), 2500);
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center gap-3" data-testid="auth-callback">
      {error ? (
        <p className="text-destructive text-sm px-8 text-center">{error}</p>
      ) : (
        <>
          <Loader2 className="w-6 h-6 animate-spin text-primary" />
          <p className="text-muted-foreground text-sm">Completing sign-in…</p>
        </>
      )}
    </div>
  );
}
